import { createFileRoute } from '@tanstack/react-router';

import { panelsService } from '@/app/services/panelsService';
import { LaunchScreen } from '@/view/components/modules/launch-screen';
import { ActivatePanel } from '@/view/pages/ActivatePanel';

export const Route = createFileRoute('/ativar-painel-operacao')({
  component: ActivatePanel,
  pendingComponent: () => <LaunchScreen isLoading />,
  loader: () => {
    const urlParams = new URLSearchParams(window.location.search);
    const deviceCode = urlParams.get('mac');
    const groupName = urlParams.get('grupo');

    return panelsService.createPanel({ deviceCode, groupName });
  },
});
